export const useSpinner = defineStore('spinner', () => {
  const visible = ref(false)

  function open() {
    visible.value = true
  }

  function close() {
    visible.value = false
  }

  return { visible: readonly(visible), open, close }
})
